// ════════════════════════════════════════════════════════════════════════
//  Die Breite einer Seite
//
//  Der Regelfall im Dashboard ist WEIT: Listen und Tabellen sind der Inhalt
//  dieser App. Schmal ist die Ausnahme und heißt `text` – Fließtext und
//  Formulare, wo eine Zeile über 27 Zoll niemand liest.
//
//  Es gab kurz eine mittlere Stufe für Listen. Sie erzeugte genau den Bruch, der
//  sie widerlegt hat: /classes blieb schmal, /classes/:id daneben war breit, und
//  beim Wechsel sprang die Seite. Eine Liste ist keine andere Art von Inhalt als
//  ihre Detailseite.
//
//  Gewählt wird in `App.tsx`, direkt an der Route. Dort stehen alle Seiten
//  untereinander, und die Zuordnung ist auf einen Blick zu prüfen – NIE am
//  Pfadpräfix: so entstand in der Admin-App die Lehrgangsliste, die die Breite
//  der Arbeitsfläche erbte.
// ════════════════════════════════════════════════════════════════════════

import type { ReactNode } from "react";
import styles from "./shell.module.css";

/**
 * `weit` – der Regelfall: Listen, Tabellen, Arbeitsflächen.
 * `text` – Fließtext und Formulare.
 */
export type PageWidth = "weit" | "text";

const widths: Record<PageWidth, string> = {
  weit: styles.breiteWeit!,
  text: styles.breiteText!,
};

export function Page({
  width = "weit",
  children,
}: {
  width?: PageWidth;
  children: ReactNode;
}) {
  return <div className={`${styles.page} ${widths[width]}`}>{children}</div>;
}
